import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { HearAboutTenetVariants } from 'enums/onboarding/crm';
import { SelectOption, SelectProps } from '@ui';

// components
import { FormSelect } from '@ui';

type IProps = SelectProps;

const HearAboutTenetSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(() => {
    return [
      {
        id: HearAboutTenetVariants.Website,
        label: t(
          `intake_form.hear_about_tenet_variants.${HearAboutTenetVariants.Website}`,
        ),
      },

      {
        id: HearAboutTenetVariants.Employee,
        label: t(
          `intake_form.hear_about_tenet_variants.${HearAboutTenetVariants.Employee}`,
        ),
      },

      {
        id: HearAboutTenetVariants.Referrer,
        label: t(
          `intake_form.hear_about_tenet_variants.${HearAboutTenetVariants.Referrer}`,
        ),
      },

      {
        id: HearAboutTenetVariants.Other,
        label: t(
          `intake_form.hear_about_tenet_variants.${HearAboutTenetVariants.Other}`,
        ),
      },
    ];
  }, [t]);

  return <FormSelect {...props} options={options} />;
};

export default HearAboutTenetSelect;
